import { Routers } from "./components/Routers";

const App = () => {
  return <Routers />;
}

export default App;
